/**
 * WordPress dependencies
 */

import { store, getContext, getServerState, getElement } from '@wordpress/interactivity';



const { state } = store('gt/ctv', {
    state:{
        // get stays(){
        //     return [];
        // }
    },
    actions: {
        // setStays: async () => {

        //     if(state.isLoading = false) return;

        //     const serverState = getServerState( "gt/ctv" );
        //     state.stays = serverState.stays;

        //     state.isLoading = false;

        //     const event = new CustomEvent('gt_ws_ctv_updated');
        //     window.dispatchEvent(event);

        //     if (document.querySelector('.gt-hebergements-filtres')) {
        //         store('gt/ctv/filtres').actions.runFilters();
        //     }
            
        // },
        changeNbPers: (e) => {
            const context = getContext();
            let nbPers = e.target.value;
            context.gtNbPers = nbPers;
            state.gtNbPers = nbPers;
        },
        changeType: (e) => {
            const context = getContext();
            let gtType = e.target.value;
            context.gtType = [gtType];
            state.gtType = [gtType];
            Cookies.set('gtType', [gtType]);
        },
        changeCamping: (e) => {
            const context = getContext();
            let gtCamping = e.target.value;
            context.gtCamping = gtCamping;
            state.gtCamping = gtCamping;
        },
        setCaleran: () => {
            let language = 'fr';
            if (jQuery('html').attr('lang')) {
                language = jQuery('html').attr('lang').slice(0, 2);
            }

            const context = getContext();
            const { gtArrival, gtDeparture } = state;

            const element = getElement();

            const generateRanges = (arrivalDate) => {
                const arrivalMoment = moment(arrivalDate);
                const ranges = [];

                const getNextWeekday = (date, weekday) => {
                    let diff = weekday - date.day();
                    if (diff <= 0) diff += 7;
                    return date.clone().add(diff, 'days');
                };

                ranges.push({
                    title: '1 semaine',
                    startDate: arrivalMoment,
                    endDate: arrivalMoment.clone().add(1, 'weeks')
                });

                ranges.push({
                    title: '2 semaines',
                    startDate: arrivalMoment,
                    endDate: arrivalMoment.clone().add(2, 'weeks')
                });

                ranges.push({
                    title: '3 semaines',
                    startDate: arrivalMoment,
                    endDate: arrivalMoment.clone().add(3, 'weeks')
                });

                const startWednesday = getNextWeekday(arrivalMoment, 3);
                ranges.push({
                    title: 'Du mercredi au mercredi',
                    startDate: startWednesday,
                    endDate: startWednesday.clone().add(1, 'weeks')
                });

                const startFriday = getNextWeekday(arrivalMoment, 5);
                ranges.push({
                    title: 'Du vendredi au vendredi',
                    startDate: startFriday,
                    endDate: startFriday.clone().add(1, 'weeks')
                });

                const startSaturday = getNextWeekday(arrivalMoment, 6);
                ranges.push({
                    title: 'Du samedi au samedi',
                    startDate: startSaturday,
                    endDate: startSaturday.clone().add(1, 'weeks')
                });

                return ranges;
            };

            if(jQuery('.gt-caleran-merged').length){
                jQuery('.gt-caleran-merged').caleran({
                    startDate: moment(gtArrival),
                    endDate: moment(gtDeparture),
                    minDate: moment(state.openingDate) < moment() ? moment() : moment(state.openingDate),
                    maxDate: moment(state.closingDate),
                    hideOutOfRange: true,
                    enableSwipe: true,
                    startOnMonday: true,
                    enableKeyboard: true,
                    autoCloseOnSelect: true,
                    locale: language,
                    enableMonthSwitcher: true,
                    enableYearSwitcher: true,
                    ranges: generateRanges(gtArrival),
                    format: language === "en" ? "DD/MM/YYYY" : "DD/MM/YYYY",
                    onafterselect: function (caleran, startDate, endDate) {

                        state.gtArrival = startDate.format('DD/MM/YYYY');
                        state.gtDeparture = endDate.format('DD/MM/YYYY');
                                                
                        if (caleran.$elem.closest('.gt-ws-ctv-form-resa').find('button[type="submit"]').length <= 0) {                        
                            state.isLoading = true;
                            state.loaded = false;
                        }
                        
                        caleran.config.ranges = generateRanges(state.gtArrival);
                        caleran.reDrawCalendars();

                        jQuery(".gt-caleran-merged, .gt-caleran-arrival, .gt-arrival-departure").each(function(){
                            var caleran = jQuery(this).data("caleran");    
                            caleran.config.startDate = startDate;
                            caleran.config.endDate = endDate;
                            caleran.reDrawCalendars();
                        });

                    }
                });
            }
            else{

                var startDate, endDate, startInstance, endInstance;
                var fillInputs = function () {
                    startInstance.$elem.val(startDate ? startDate.locale(startInstance.config.format).format(startInstance.config.format) : "");
                    endInstance.$elem.val(endDate ? endDate.locale(endInstance.config.format).format(endInstance.config.format) : "");
                };

                jQuery('.gt-caleran-arrival').caleran({
                    startDate: moment(gtArrival),
                    endDate: moment(gtDeparture),
                    minDate: moment(state.openingDate) < moment() ? moment() : moment(state.openingDate),
                    maxDate: moment(state.closingDate),
                    hideOutOfRange: true,
                    enableSwipe: true,
                    startOnMonday: true,
                    enableKeyboard: true,
                    autoCloseOnSelect: true,
                    locale: language,
                    enableMonthSwitcher: true,
                    enableYearSwitcher: true,
                    ranges: generateRanges(gtArrival),
                    format: language === "en" ? "DD/MM/YYYY" : "DD/MM/YYYY",
                    oninit: function (instance) {
                        startInstance = instance;
                        if (!instance.config.startEmpty && instance.config.startDate) {
                            instance.$elem.val(instance.config.startDate.locale(instance.config.format).format(instance.config.format));
                            startDate = instance.config.startDate.clone();
                        }
                    },
                    onbeforeshow: function (instance) {
                        if (startDate) {
                            startInstance.config.startDate = startDate;
                            endInstance.config.startDate = startDate;
                        }
                        if (endDate) {
                            startInstance.config.endDate = endDate.clone();
                            endInstance.config.endDate = endDate.clone();
                        }
                        fillInputs();
                        instance.updateHeader();
                        instance.reDrawCells();
                    },
                    onfirstselect: function (instance, start) {
                        startDate = start.clone();
                        startInstance.globals.startSelected = false;
                        startInstance.hideDropdown();
                        endInstance.showDropdown();
                        endInstance.config.minDate = startDate.clone();
                        endInstance.config.startDate = startDate.clone();
                        endInstance.config.endDate = null;
                        endInstance.globals.startSelected = true;
                        endInstance.globals.endSelected = false;
                        endInstance.globals.firstValueSelected = true;
                        endInstance.setDisplayDate(start);
                        if (endDate && startDate.isAfter(endDate)) {
                            endInstance.globals.endDate = endDate.clone();
                        }
                        endInstance.updateHeader();
                        endInstance.reDrawCells();
                        fillInputs();
                    }
                });

                jQuery('.gt-caleran-departure').caleran({
                    startDate: moment(gtArrival),
                    endDate: moment(gtDeparture),
                    minDate: moment(state.openingDate) < moment() ? moment() : moment(state.openingDate),
                    maxDate: moment(state.closingDate),
                    hideOutOfRange: true,
                    enableSwipe: true,
                    startOnMonday: true,
                    enableKeyboard: true,
                    autoCloseOnSelect: true,
                    locale: language,
                    enableMonthSwitcher: true,
                    enableYearSwitcher: true,
                    ranges: generateRanges(gtArrival),
                    format: language === "en" ? "DD/MM/YYYY" : "DD/MM/YYYY",
                    oninit: function (instance) {
                        endInstance = instance;
                        if (!instance.config.startEmpty && instance.config.endDate) {
                            instance.$elem.val(instance.config.endDate.locale(instance.config.format).format(instance.config.format));
                            endDate = instance.config.endDate.clone();
                        }
                    },
                    onbeforeshow: function (instance) {
                        if (startDate) {
                            startInstance.config.startDate = startDate;
                            endInstance.config.startDate = startDate;
                        }
                        if (endDate) {
                            startInstance.config.endDate = endDate.clone();
                            endInstance.config.endDate = endDate.clone();
                        }
                        fillInputs();
                        instance.updateHeader();
                        instance.reDrawCells();
                    },
                    onafterselect: function (instance, start, end) {
                        startDate = start.clone();
                        endDate = end.clone();
                        endInstance.hideDropdown();
                        startInstance.config.endDate = endDate.clone();
                        startInstance.globals.firstValueSelected = true;
                        fillInputs();
                        endInstance.globals.startSelected = true;
                        endInstance.globals.endSelected = false;
                        
                        state.gtArrival = start.format('DD/MM/YYYY');
                        state.gtDeparture = end.format('DD/MM/YYYY');

                        instance.config.ranges = generateRanges(state.gtArrival);
                        instance.reDrawCalendars();


                        jQuery(".gt-caleran-merged, .gt-caleran-arrival, .gt-arrival-departure").each(function(){
                            var caleran = jQuery(this).data("caleran");    
                            caleran.config.startDate = startDate;
                            caleran.config.endDate = endDate;
                            caleran.reDrawCalendars();
                        });

                    }
                });
            }

        },
        toggleStickyForm: (e) => {
            const element = getElement();
            element.ref.closest('.wp-block-gt-gt-ws-ctv-form-resa').classList.toggle('toggled');
        },
        stickyForm: (e) => {
            e.preventDefault();
            const element = getElement();
            const context = getContext();

            const elementBottom = element.ref.getBoundingClientRect().bottom + window.scrollY;
            const trigger = context.isStickyAfterScroll ? context.isStickyAfterScroll : elementBottom
            

            const scrollTop = window.scrollY;

            if (scrollTop > 10) {
                element.ref.classList.add('sticked');
            } else {
                element.ref.classList.remove('sticked');
            }

            element.ref.classList.remove('toggled');


        },
        submitForm: (e) => {

            const url = new URL(window.location.href);
            if (url.searchParams.has('gtNoResults')) {
                state.isLoading = true;
            }


            if(state.loaded == true && e == undefined) return;

            state.isLoading = true;
            state.loaded = false;

            if(state.gtArrival == "null" || state.gtDeparture == "null" || state.gtNbPers == "null"){
                state.isLoading = false;
                return;
            }


            if(e) e.preventDefault();

            fetch(`${state.baseUrl}disponibilites/?arrival=${state.gtArrival}&departure=${state.gtDeparture}&nbPers=${state.gtNbPers}&lang=${state.language}&site_id=${state.siteId}`)
                .then(response => response.json())
                .then(disponibilitesData => {
                    let stays = {};
                    state.allProductIds.forEach(productId => {
                        stays[productId] = disponibilitesData[productId] || [];
                    });
                    state.stays = stays;


                    // If all empty arrays
                    if (Object.values(stays).every(arr => arr.length === 0)) {
                        if (!url.searchParams.has('gtNoResults')) {
                            url.searchParams.set('gtNoResults', 'true');
                            updateURL(url);
                            return;
                        }
                    }


                })
                .catch(error => console.error("Erreur lors de la récupération des disponibilités:", error))
                .finally(() => {
                    state.isLoading = false;
                    state.loaded = true;

                    const domSort = document.querySelector('.gt-hebergements-sort input[type="radio"]:checked');
                    if (domSort) {
                        state.sort_order = domSort.value;
                    }
                    
                    document.querySelectorAll('.wp-block-post-template')
                    .forEach(container => {
                        const hebergements = [...container.querySelectorAll('.hebergement')];

                        hebergements.sort((a, b) => {
                            const priceA = parseFloat(a.querySelector('.gt-ws-ctv-data-price')?.dataset.gtPrice) || 0;
                            const priceB = parseFloat(b.querySelector('.gt-ws-ctv-data-price')?.dataset.gtPrice) || 0;

                            return state.sort_order === 'asc' ? priceA - priceB : priceB - priceA;
                        });

                        const fragment = document.createDocumentFragment();
                        hebergements.forEach(hebergement => fragment.appendChild(hebergement));
                        container.appendChild(fragment);
                    });


                });


            Cookies.set('gtArrival', state.gtArrival);
            Cookies.set('gtDeparture', state.gtDeparture);
            Cookies.set('gtNbPers', state.gtNbPers);
            Cookies.set('gtType', state.gtType);
            Cookies.set('gtCamping', state.gtCamping);

            // Définir les paramètres GET dans l'URL
            url.searchParams.set('arrival', state.gtArrival);
            url.searchParams.set('departure', state.gtDeparture);
            url.searchParams.set('nbPers', state.gtNbPers);

            // Mise à jour de l'URL sans recharger la page
            window.history.pushState({}, '', url.toString());


            // Close menu
            if(store('gt-menu-burger').actions.length > 0){
                store('gt-menu-burger').actions.closeMenu();
            }
            
            if(e && e.type == "submit" ){

                const context = getContext();
                const destinationUrl = new URL(context.destination ? context.destination : window.location);    
                destinationUrl.searchParams.set('arrival', state.gtArrival);
                destinationUrl.searchParams.set('departure', state.gtDeparture);
                destinationUrl.searchParams.set('nbPers', state.gtNbPers);
                destinationUrl.searchParams.delete('gtNoResults');

                if(window.location.toString() != destinationUrl.toString() || !context.destination){
                    window.location.replace(destinationUrl.toString());
                }
            }   
        },
        callbacks:{
          
        }
    }
});

const updateURL = async (url) => {
    const router = await import('@wordpress/interactivity-router');
    
    // await router.actions.prefetch(url.toString(),{
    //     // force:false
    // });

    // Navigate to the updated URL
    await router.actions.navigate(url.toString(), {
        // force:true,
        // replace:true,
        // timeout:20000
    });

    state.isLoading = false;

};
